var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLeave = function SvgLeave(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 5V19C20 20.657 18.657 22 17 22H7C5.343 22 4 20.657 4 19V5C4 3.343 5.343 2 7 2H17C18.657 2 20 3.343 20 5Z",
    fill: "#F3CED2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10H11C9.895 10 9 10.895 9 12C9 13.105 9.895 14 11 14H18V10Z",
    fill: "#EA5353"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5791 16.1306C16.5791 16.9016 17.5091 17.2896 18.0571 16.7466L21.9501 12.8906C22.4451 12.3996 22.4451 11.5996 21.9501 11.1086L18.0571 7.25259C17.5091 6.71059 16.5791 7.09859 16.5791 7.86859V16.1306Z",
    fill: "#EA5353"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLeave);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "leave.0340ccada3272ab16e76307f50c3389f.svg";